import { LiveEvent, LiveEvent$Details, LiveEvent$TextOverlay } from '../types/Live';
import { LiveEvent$Status } from '@Ravnur-Inc/shared/types/Live';
import BaseRepository, { PagedListResponse } from '@/repositories/base-repository';

import { SortType } from '@/transformers/sort-by';
import { get, put } from '@/helpers/http';

export interface LiveEventsQueryParams {
  q: string;
  sortField: string;
  sortType: SortType;
  offset: number;
  count: number;
  status: LiveEvent$Status | LiveEvent$Status[];
  channelId: string;
}

type PLR = PagedListResponse<LiveEvent>;
export default class LiveEventsRepository extends BaseRepository<
  LiveEvent$Details,
  LiveEventsQueryParams,
  PLR
> {
  constructor() {
    super('/live/event');
  }

  public async removeSplash(eventId: string) {
    return this.undo(eventId, 'splash');
  }

  public uploadSplash(file: File, eventId: string) {
    return this._upload(file, `${eventId}/splash`);
  }

  public async gotoPreview(event: LiveEvent) {
    return this.action(event, 'preview');
  }

  public async stopPreview(event: LiveEvent) {
    return this.undo(event.id, 'preview');
  }

  public async gotoLive(event: LiveEvent) {
    return this.action(event, 'live');
  }

  public async stopLive(event: LiveEvent) {
    return this.undo(event.id, 'live');
  }

  public async updateCrawlText(eventId: string, crawl: LiveEvent$TextOverlay) {
    return put(`${this._resource}/${eventId}/textoverlay`, crawl);
  }

  public async getCrawlText(eventId: string) {
    return get(`${this._resource}/${eventId}/textoverlay`);
  }
}
